import { constants } from 'quasar-pilot-core/src/lib/constants';

constants.DEFAULT_LOCATION = 1;
constants.DEFAULT_DELIVERY_METHOD = 1;
constants.DEFAULT_PAYMENT_METHOD = 1;

constants.SESSION_COOKIE_USER_ID = 'userUid';
constants.SESSION_COOKIE_LOCATION_ID = 'locationUid';

export default constants;
